export default {"src":"/_next/static/media/500_image.5f7090bf.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};